module.exports = __webpack_public_path__ + "img/evaluation.0bd9fc03.svg";